import { useEffect, useState } from 'react';
import { Cookies } from 'react-cookie';
import { deleteCompetitionTeam, fetchCompetitionEventTeams, deactivateTeam, fetchRepTeams } from '../api/api';
import Card from './Card';
import TeamCardWithActions from './TeamCardWithActions';
import FlashMessage from './FlashMessage';
import Header from './Header';
import Stack from './Stack';

function TeamIndex(props) {
  const {
    setTeamMembers,
    setStep,
    setEditingTeam,
    setEditingTeamId,
    setTeam
  } = props;

  const [competitionTeams, setCompetitionTeams] = useState([]);
  const [error, setError] = useState('')
  const [errorType, setErrorType] = useState(null);
  const cookies = new Cookies();
  const userBadgeId = cookies.get('userBadgeId');

  useEffect(() => {
    fetchRepTeams(userBadgeId)
      .then((teams) => (
        setCompetitionTeams(teams)
      ))
      .catch((err) => {
        setError(err.message);
        setErrorType('failure');
      });
  }, []);

  const handleEditTeam = async (team) => {
    await deactivateTeam(team.id);
    setEditingTeam(true);
    setTeamMembers(team.competition_team_members);
    setTeam(team);
    setEditingTeamId(team.id);
    setStep(2);
  };

  const removeTeam = async (team) => {
    try {
      await deleteCompetitionTeam(team.id);
      const teams = await fetchRepTeams(userBadgeId);
      setCompetitionTeams(teams);
    } catch (err) {
      setError(err.message);
      setErrorType('failure');
    }
  };

  return (
    <Card className="gap-6">
      <FlashMessage message={error} type="error" onClose={() => { setError(''); setErrorType(null); }} />
      <Stack width="full" align="start" direction='col'>
        <Header size='lg'>
          My Teams
        </Header>
        <p className='text-sm'>View your teams</p>
      </Stack>
      <FlashMessage />
      <Stack width='full' direction='col' justify='center' align='center'>
        {competitionTeams?.map((team) => (
          <TeamCardWithActions
            key={team.id}
            team={team}
            competition={team.competition}
            competition_event={team.competition_event}
            userBadgeId={userBadgeId}
            onEdit={handleEditTeam}
            onDelete={removeTeam}
          />
        ))}
      </Stack>
    </Card>
  );
}

export default TeamIndex;
